// SEE: https://getslick.atlassian.net/browse/GS-11131?focusedCommentId=15154

const BUSINESS_TYPE = Object.freeze({
  other: 'other', // Other
  //
  salonHair: 'salon-hair', // Hair salon
  salonBeauty: 'salon-beauty', // Beauty salon
  salonHnB: 'salon-hair-beauty', // Hair & beauty salon
  //
  barbers: 'barbers', // Barbers
  hbnb: 'hair-beauty-barber', // Hair, beauty & barbering
  //
  mobileHair: 'mob-home-hair', // Mobile / home hairdresser
  mobileBeauty: 'mob-home-beauty', // Mobile / home beautician
  //
  medical: 'medical', // Aesthetics / Medical
  physio: 'physio', // Physio therapy
  //
  groomDog: 'groom-dog', // Dog grooming
  //
  train: 'train', // College / Training Academy
});

// noinspection JSUnusedGlobalSymbols
export default BUSINESS_TYPE;
